import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { confirmAlert } from 'react-confirm-alert';
import { Col, Tooltip, OverlayTrigger } from 'react-bootstrap';

//components
import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '../../../hoc/withLocalization.js';
import Button from '../../../components/CustomButton/CustomButton.jsx';
import FlexCard from '~/components/Card/FlexCard.jsx';

//utils
import { minutesToTimeInput } from '../../../utils/timeCalc.js';
import { shortDateFormat } from '../../../utils/dateFormat.js';

//assets
import urgentWorkIcon from '../../../assets/img/urgent_icon.svg';

class TimelogWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: null,
            emergencyShiftDeatils: {},
            employeeIsAssignedForEmergencyShift: false,
            urgentCallDeatils: {},
            employeeIsAssignedForUrgentCall: false
        };
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        const { timelogStore } = this.props;
        const status = await timelogStore.getCurrentDraftOrSkip('', '', true);
        this.setState({
            status,
            emergencyShiftDeatils: status.emergencyShiftDeatils,
            employeeIsAssignedForEmergencyShift: status.employeeIsAssignedForEmergencyShift,
            urgentCallDeatils: status.urgentCallDeatils,
            employeeIsAssignedForUrgentCall: status.employeeIsAssignedForUrgentCall
        });
        return null;
    }

    async handleStop() {
        return this.props.router.navigate(`/admin/timelogs/${this.state.status.timelog.id}`, { state: { timelogs: this.state.status.timelog.id, finishTimelog: true } });
    }

    async handleStart() {
        const { commonStore, t } = this.props;
        const { status } = this.state;
        if (!status.timelog) {
            const state = {};
            if (status.shift) {
                state.shiftProjectId = status.shift.project_id;
                state.shiftTaskId = status.shift.task_id;
                state.shiftProjectName = status.shift.project_name;
                state.shiftTaskName = status.shift.task_name;
                state.shiftTaskNumber = status.shift.task_number;
                state.shiftProjectNumber = status.shift.project_number;
                state.shiftId = status.shift.shift_id;
            } else {
                commonStore.addNotification(t('Please choose the task and click Start'), null, 'warning');
            }
            this.props.router.navigate('/admin/timelogs/add', { state });
            return null;
        }

        return null;
    }

    renderStartButton() {
        const { t } = this.props;
        return (
            <div className="flex-card-footer-buttons">
                <Button fill style={{ width: '100%' }} onClick={() => this.handleStart()}>
                    {t('Start')}
                </Button>
            </div>
        );
    }

    async onPause() {
        const { status } = this.state;
        const { timelogStore, commonStore, t } = this.props;
        const isPaused = status.timelog.tracker_status === 'break';
        try {
            await timelogStore.breakByButton(status.timelog.id, isPaused ? 'stop' : 'start', false);
        } catch (error) {
            console.error('Error toggling break:', error);
            commonStore.addNotification(t('Something went wrong'), null, 'error');
        }
        this.loadData();
    }

    renderStopAndBreak = () => {
        const { status } = this.state;
        const { t } = this.props;
        const { data: clientData } = this.props.commonStore.config.client;
        const hideBreakButton = clientData.basicRules && clientData.basicRules.hideBreakButton ? clientData.basicRules.hideBreakButton : false;
        const isPaused = status.timelog.tracker_status === 'break';
        return (
            <div className="flex-card-footer-buttons">
                <Button fill onClick={() => this.handleStop()}>
                    {t('Finish')}
                </Button>
                {!hideBreakButton &&
                    <Button onClick={() => this.onPause()}>{isPaused ? t('Finish break') : t('Start break')}</Button>
                }
            </div>
        );
    };

    cancelRequest = async (cancellationPayload) => {
        return confirmAlert({
            title: cancellationPayload.error,
            message: cancellationPayload.errorMessage,
            buttons: [
                {
                    label: this.props.t('Cancel And Proceed'),
                    onClick: () => {
                        return this.props.timelogStore.cancelPendingAbsenceOrVacation(cancellationPayload.cancellationLink).then((res) => {
                            this.props.commonStore.addNotification(this.props.t(res.message), null, 'success');
                            this.handleStart();
                        }).catch((err) => {
                            this.props.commonStore.addNotification(this.props.t(err), null, 'error');
                        })
                    },
                },
                {
                    label: this.props.t('Check And Cancel Manually'),
                    onClick: () => {
                        return this.props.router.navigate(`/admin/${cancellationPayload.requestType}s`);
                    },
                },
            ],
        });
    }

    render() {
        const { t, commonStore } = this.props;
        const { status, emergencyShiftDeatils, employeeIsAssignedForEmergencyShift, urgentCallDeatils, employeeIsAssignedForUrgentCall } = this.state;
        if (!status) return null;
        let emergencyShift = '';
        let urgentShift = '';
        const dateTimeRules = commonStore.getDateTimeRules();
        if (employeeIsAssignedForEmergencyShift) {
            emergencyShift = (
                <OverlayTrigger
                    key="bottom"
                    placement="bottom"
                    overlay={
                        <Tooltip id="tooltip-bottom">
                            <div>{t("You have been assigned to handle emergency shifts(on-call)")}</div>
                            {`${t('From')} - ${shortDateFormat(emergencyShiftDeatils?.fromDate, dateTimeRules)} | ${t('To')} - ${shortDateFormat(emergencyShiftDeatils?.toDate, dateTimeRules)}`}
                        </Tooltip>
                    }
                >
                    <div className='font-size-12 text-bg-danger border-radius-10 custom-padding-timelog-widget'>{t('On Call')}</div>
                </OverlayTrigger>
            )
        }
        if (employeeIsAssignedForUrgentCall) {
            urgentShift = (
                <OverlayTrigger
                    key="urgent-call"
                    placement="bottom"
                    overlay={
                        <Tooltip id="tooltip-urgent">
                            <div>
                                {t("You have been assigned to handle urgent work")} ({urgentCallDeatils.type})
                            </div>
                        </Tooltip>
                    }
                >
                    <img src={urgentWorkIcon} alt={t("Urgent work")} style={{ width: '24px', height: '24px' }} />
                </OverlayTrigger>
            )
        }

        const combinedIcons = (
            <div className="d-flex gap-1 align-items-center">
                {emergencyShift && <div>{emergencyShift} </div>}
                {urgentShift && <div>{urgentShift}</div>}
            </div>
        )
        return (
            <Fragment>
                <Col sm={6} lg={3}>
                    {!status.timelog && !status.shift && (
                        <FlexCard
                            title={t('Timelog')}
                            desc={t('No work right now')}
                            icon={<i className="pe-7s-clock text-warning" />}
                            footer={this.renderStartButton()}
                            additionalImg={combinedIcons}
                        />
                    )}
                    {!!status.shift && !status.timelog && (
                        <FlexCard
                            title={t('Timelog')}
                            desc={`${status.shift.project_name} / ${status.shift.task_name}`}
                            icon={<i className="pe-7s-clock text-warning" />}
                            footer={this.renderStartButton()}
                            additionalImg={combinedIcons}
                        />
                    )}
                    {!!status.timelog && (
                        <FlexCard
                            title={t('Timelog')}
                            desc={`${t('Started at')} ${minutesToTimeInput(status.timelog.from, true)}`}
                            icon={<i className="pe-7s-clock text-success" />}
                            footer={this.renderStopAndBreak()}
                            additionalImg={combinedIcons}
                        />
                    )}
                </Col>
            </Fragment>
        );
    }
}

export default inject('timelogStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(TimelogWidget))));
